import { actions } from '../configurations/constants';

const initial = {
  consignorList: [],
  consignorGroup: [],
  consignor: {}
};

const consignorHome = (state = initial, action = {}) => {
  switch (action.type) {
    case actions.ADD_CONSIGNOR_LIST:
      return {
        ...state,
        consignorList: action.payload
      };
    case actions.ADD_CONSIGNOR_GROUP:
      return {
        ...state,
        consignorGroup: action.payload
      };
    case actions.SET_CONSIGNOR:
      return {
        ...state,
        consignor: action.payload
      };
    default:
      return state;
  }
};

export default consignorHome;
